const SYMBOLS = { BRL: "R$", USD: "$", EUR: "€", GBP: "£", CAD: "C$", AUD: "A$", JPY: "¥", CHF: "CHF ", CNY: "¥", MXN: "MX$" };

export function money(value, currency = "BRL") {
  const n = Number(value || 0);
  const sym = SYMBOLS[currency] || "";
  return `${sym}${n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function pct(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}
